// Per-device preference: skip Confirm-tier tool approvals for every turn.
// Same posture as memoryPrefs.ts — a per-user setting with no server-side
// table, kept in localStorage. Default off: the confirmation gate stays the
// default, and this is the explicit "dangerously skip permissions" override.
const SKIP_TOOL_CONFIRMATIONS_KEY = "chatclient.skipToolConfirmations";

export function loadSkipToolConfirmations(): boolean {
  try {
    return localStorage.getItem(SKIP_TOOL_CONFIRMATIONS_KEY) === "true";
  } catch {
    return false;
  }
}

export function saveSkipToolConfirmations(value: boolean): void {
  try {
    localStorage.setItem(SKIP_TOOL_CONFIRMATIONS_KEY, String(value));
  } catch {
    // Storage is a convenience, not a requirement for the current session.
  }
}
